import React, { useEffect, useState } from 'react';
import { AppointmentTypeQuestion } from '../../../../../api/models';
import {
  DropdownField,
  RadioCardGroup,
  RadioCardOptionOrientation,
  RadioCardSizing,
} from '../../../../../core';

export interface AppointmentInfoQuestionProps {
  question: AppointmentTypeQuestion;
  selectedAnswer?: string;
  validate?: boolean;
  onAnswerChanged: (answerId: string) => void;
}

const AppointmentInfoQuestion: React.FC<AppointmentInfoQuestionProps> = (
  props: AppointmentInfoQuestionProps
) => {
  const [selectedAnswer, setSelectedAnswer] = useState<string>(
    props.selectedAnswer ?? ''
  );

  useEffect(() => {
    setSelectedAnswer(props.selectedAnswer ?? '');
  }, [props.selectedAnswer]);

  const questionLabel =
    props.question.questionText ?? '<Missing question text>';

  const onAnswerChanged = (answerId: string) => {
    props.onAnswerChanged(answerId);
  };

  return (
    <div>
      {props.question.answerList && props.question.answerList.length > 2 ? (
        <DropdownField
          label={questionLabel}
          options={
            props.question.answerList
              ? [
                  { text: '', value: '' },
                  ...props.question.answerList.map((answer) => {
                    return {
                      text: answer.answerText ?? '',
                      value: answer.answerId ?? '',
                    };
                  }),
                ]
              : []
          }
          selectedValue={selectedAnswer}
          required={props.question.required}
          validate={props.validate}
          onItemPicked={onAnswerChanged}
        />
      ) : (
        <RadioCardGroup
          label={questionLabel}
          groupName={`Question_${props.question.questionId}`}
          required={props.question.required}
          sizing={RadioCardSizing.Small}
          fullWidth={true}
          radioOptions={
            props.question.answerList
              ? props.question.answerList.map((answer) => {
                  return {
                    label: answer.answerText ?? '',
                    value: answer.answerId ?? '',
                  };
                })
              : []
          }
          selectedValue={selectedAnswer}
          orientation={RadioCardOptionOrientation.Vertical}
          validate={props.validate}
          onChange={onAnswerChanged}
        />
      )}
    </div>
  );
};

export default AppointmentInfoQuestion;
